module.exports = __webpack_public_path__ + "img/card_bg.e67c8a2b.svg";